export default {
    footerItems: {
        footerLogo: { src: '/img/checkbook_logo_black.png', text: 'Checkbook' },
        tos:
            '*Card is issued by Pathward® N.A., Member FDIC, pursuant to a license from Visa USA Inc. Everywhere Visa debit cards are accepted within the United States. No ATM or cash access. Terms and conditions may apply. Currently available only within the US and Canada.',
        columns: [
            {
                rows: [
                    {
                        name: 'Products',
                        items: [
                            {
                                name: 'Payments',
                                src: '/product/payments/',
                            },
                            {
                                name: 'Invoices',
                                src: '/product/invoices/',
                            },
                        ],
                    },
                    {
                        name: 'Developer',
                        items: [
                            {
                                name: 'Documentation',
                                src: 'https://docs.checkbook.io/docs?auth_token=eyJ0eXAiOiJKV1QiLCJhbGciOiJIUzI1NiJ9.eyJuYW1lIjoiQ2hlY2tib29rIERlbW8iLCJlbWFpbCI6ImRlbW9AY2hlY2tib29rLmlvIiwiZW52IjoiZGVtbyIsImFwaUtleSI6ImQ2YWEyNzAzNjU1ZjRiYTJhZjJhNTYyMDI5NjFjYTg2OmRYYkNnellCTWliajhad3VRTWQyTlhyNnJ0dmpaOCJ9.ucRb-jixtaVao7CVAWpH4LhiGZcytfQZfFTxOc1z7JQ',
                            },
                            {
                                name: 'API Reference',
                                src: 'https://docs.checkbook.io/reference?auth_token=eyJ0eXAiOiJKV1QiLCJhbGciOiJIUzI1NiJ9.eyJuYW1lIjoiQ2hlY2tib29rIERlbW8iLCJlbWFpbCI6ImRlbW9AY2hlY2tib29rLmlvIiwiZW52IjoiZGVtbyIsImFwaUtleSI6ImQ2YWEyNzAzNjU1ZjRiYTJhZjJhNTYyMDI5NjFjYTg2OmRYYkNnellCTWliajhad3VRTWQyTlhyNnJ0dmpaOCJ9.ucRb-jixtaVao7CVAWpH4LhiGZcytfQZfFTxOc1z7JQ',
                            },
                        ],
                    },
                ],
            },
            {
                rows: [
                    {
                        name: 'Company',
                        items: [
                            { name: 'About Us', src: '/company/about-us/' },
                            { name: 'How it Works', src: '/company/how-it-works/' },
                            { name: 'Pricing', src: '/pricing/' },
                            { name: 'FAQ', src: 'https://faq.checkbook.io/' },
                            { name: 'Compliance', src: '/company/compliance/' },
                            { name: 'Security', src: '/company/security/' },
                            { name: 'Careers', src: 'https://boards.greenhouse.io/checkbook' },
                        ],
                    },
                ],
            },
            {
                rows: [
                    {
                        name: 'Solutions',
                        items: [
                            {
                                name: 'Multi-party',
                                src: 'https://docs.checkbook.io/docs/products/payments/multiparty/',
                            },
                            {
                                name: 'PayFac Marketplace',
                                src: 'https://docs.checkbook.io/docs/products/marketplace/',
                            },
                            {
                                name: 'Integrations',
                                src: 'https://docs.checkbook.io/docs/',
                            },
                        ],
                    },
                    {
                        name: 'Resources',
                        items: [
                            {
                                name: 'Blog',
                                src: '/blog/',
                            },
                            {
                                name: 'Press',
                                src: '/press/',
                            },
                            {
                                name: 'Case Studies',
                                src: '/resource/case-studies/',
                            },
                            {
                                name: 'Logos',
                                src: '/resource/logos/',
                            },
                            {
                                name: 'Privacy',
                                src: '/resource/privacy/',
                            },
                            {
                                name: 'Terms of Service',
                                src: '/company/terms-individual/',
                            },
                        ],
                    },
                ],
            },
            {
                rows: [
                    {
                        name: 'Contact',
                        items: [
                            { name: 'support@checkbook.io' },
                            { name: '(650) 761-0008' },
                            { name: 'San Mateo, CA' },
                        ],
                    },
                    {
                        name: 'Connect',
                        items: [
                            {
                                name: 'Facebook',
                                src: 'https://www.facebook.com/Checkbook/',
                            },
                            {
                                name: 'Linkedin',
                                src: 'https://www.linkedin.com/company/checkbook/',
                            },
                            {
                                name: 'Twitter',
                                src: 'https://twitter.com/checkbook',
                            },
                        ],
                    },
                ],
            },
        ],
    },
    enca_footerItems: {
        footerLogo: { src: '/img/checkbook_logo_black.png', text: 'Checkbook' },
        tos:
            '* Terms and conditions may apply.\nCurrently available only within the US and Canada.',
        columns: [
            {
                rows: [
                    {
                        name: 'Products',
                        items: [
                            {
                                name: 'Payments',
                                src: '/en-ca/product/payments/',
                            },
                            {
                                name: 'Invoices',
                                src: '/en-ca/product/invoices/',
                            },
                        ],
                    },
                    {
                        name: 'Developer',
                        items: [
                            {
                                name: 'Documentation',
                                src: 'https://docs.checkbook.io/docs?auth_token=eyJ0eXAiOiJKV1QiLCJhbGciOiJIUzI1NiJ9.eyJuYW1lIjoiQ2hlY2tib29rIERlbW8iLCJlbWFpbCI6ImRlbW9AY2hlY2tib29rLmlvIiwiZW52IjoiZGVtbyIsImFwaUtleSI6ImQ2YWEyNzAzNjU1ZjRiYTJhZjJhNTYyMDI5NjFjYTg2OmRYYkNnellCTWliajhad3VRTWQyTlhyNnJ0dmpaOCJ9.ucRb-jixtaVao7CVAWpH4LhiGZcytfQZfFTxOc1z7JQ',
                            },
                            {
                                name: 'API Reference',
                                src: 'https://docs.checkbook.io/reference?auth_token=eyJ0eXAiOiJKV1QiLCJhbGciOiJIUzI1NiJ9.eyJuYW1lIjoiQ2hlY2tib29rIERlbW8iLCJlbWFpbCI6ImRlbW9AY2hlY2tib29rLmlvIiwiZW52IjoiZGVtbyIsImFwaUtleSI6ImQ2YWEyNzAzNjU1ZjRiYTJhZjJhNTYyMDI5NjFjYTg2OmRYYkNnellCTWliajhad3VRTWQyTlhyNnJ0dmpaOCJ9.ucRb-jixtaVao7CVAWpH4LhiGZcytfQZfFTxOc1z7JQ',
                            },
                        ],
                    },
                ],
            },
            {
                rows: [
                    {
                        name: 'Company',
                        items: [
                            { name: 'About Us', src: '/en-ca/company/about-us/' },
                            { name: 'How it Works', src: '/en-ca/company/how-it-works/' },
                            { name: 'Pricing', src: '/en-ca/pricing/' },
                            { name: 'FAQ', src: 'https://faq.checkbook.io/' },
                            { name: 'Compliance', src: '/en-ca/company/compliance/' },
                            { name: 'Security', src: '/en-ca/company/security/' },
                            { name: 'Careers', src: 'https://boards.greenhouse.io/checkbook' },
                        ],
                    },
                ],
            },
            {
                rows: [
                    {
                        name: 'Solutions',
                        items: [
                            {
                                name: 'Multi-party',
                                src: 'https://docs.checkbook.io/docs/products/payments/multiparty/',
                            },
                            {
                                name: 'PayFac Marketplace',
                                src: 'https://docs.checkbook.io/docs/products/marketplace/',
                            },
                            {
                                name: 'Integrations',
                                src: 'https://docs.checkbook.io/docs/',
                            },
                        ],
                    },
                    {
                        name: 'Resources',
                        items: [
                            {
                                name: 'Blog',
                                src: '/blog/',
                            },
                            {
                                name: 'Press',
                                src: '/press/',
                            },
                            {
                                name: 'Case Studies',
                                src: '/resource/case-studies/',
                            },
                            {
                                name: 'Logos',
                                src: '/en-ca/resource/logos/',
                            },
                            {
                                name: 'Privacy',
                                src: '/resource/privacy/',
                            },
                            {
                                name: 'Terms of Service',
                                src: '/company/terms-individual/',
                            },
                        ],
                    },
                ],
            },
            {
                rows: [
                    {
                        name: 'Contact',
                        items: [
                            { name: 'support@checkbook.io' },
                            { name: '(650) 761-0008' },
                            { name: 'San Mateo, CA' },
                        ],
                    },
                    {
                        name: 'Connect',
                        items: [
                            {
                                name: 'Facebook',
                                src: 'https://www.facebook.com/Checkbook/',
                            },
                            {
                                name: 'Linkedin',
                                src: 'https://www.linkedin.com/company/checkbook/',
                            },
                            {
                                name: 'Twitter',
                                src: 'https://twitter.com/checkbook',
                            },
                        ],
                    },
                ],
            },
        ],
    },
    frca_footerItems: {
        footerLogo: { src: '/img/checkbook_logo_black.png', text: 'Checkbook' },
        tos:
            'Les termes et conditions peuvent s\'appliquer.\nActuellement disponible uniquement aux États-Unis et Canada.',
        columns: [
            {
                rows: [
                    {
                        name: 'Produits',
                        items: [
                            {
                                name: 'Paiements',
                                src: '/fr-ca/product/payments/',
                            },
                            {
                                name: 'Facture',
                                src: '/fr-ca/product/invoices/',
                            },
                        ],
                    },
                    {
                        name: 'Développeurs',
                        items: [
                            {
                                name: 'Documentation',
                                src: 'https://docs.checkbook.io/docs?auth_token=eyJ0eXAiOiJKV1QiLCJhbGciOiJIUzI1NiJ9.eyJuYW1lIjoiQ2hlY2tib29rIERlbW8iLCJlbWFpbCI6ImRlbW9AY2hlY2tib29rLmlvIiwiZW52IjoiZGVtbyIsImFwaUtleSI6ImQ2YWEyNzAzNjU1ZjRiYTJhZjJhNTYyMDI5NjFjYTg2OmRYYkNnellCTWliajhad3VRTWQyTlhyNnJ0dmpaOCJ9.ucRb-jixtaVao7CVAWpH4LhiGZcytfQZfFTxOc1z7JQ',
                            },
                            {
                                name: 'Référence API',
                                src: 'https://docs.checkbook.io/reference?auth_token=eyJ0eXAiOiJKV1QiLCJhbGciOiJIUzI1NiJ9.eyJuYW1lIjoiQ2hlY2tib29rIERlbW8iLCJlbWFpbCI6ImRlbW9AY2hlY2tib29rLmlvIiwiZW52IjoiZGVtbyIsImFwaUtleSI6ImQ2YWEyNzAzNjU1ZjRiYTJhZjJhNTYyMDI5NjFjYTg2OmRYYkNnellCTWliajhad3VRTWQyTlhyNnJ0dmpaOCJ9.ucRb-jixtaVao7CVAWpH4LhiGZcytfQZfFTxOc1z7JQ',
                            },
                        ],
                    },
                ],
            },
            {
                rows: [
                    {
                        name: 'Entreprise',
                        items: [
                            { name: 'Qui sommes nous', src: '/fr-ca/company/about-us/' },
                            { name: 'Comment ça marche', src: '/fr-ca/company/how-it-works/' },
                            { name: 'Tarifs', src: '/fr-ca/pricing/' },
                            { name: 'FAQ', src: 'https://faq.checkbook.io/' },
                            { name: 'Conformité', src: '/fr-ca/company/compliance/' },
                            { name: 'Securité', src: '/fr-ca/company/security/' },
                            { name: 'Nous rejoindre', src: 'https://boards.greenhouse.io/checkbook' },
                        ],
                    },
                ],
            },
            {
                rows: [
                    {
                        name: 'Solutions',
                        items: [
                            {
                                name: 'Multipartite',
                                src: 'https://docs.checkbook.io/docs/products/payments/multiparty/',
                            },
                            {
                                name: 'Plateforme PayFac',
                                src: 'https://docs.checkbook.io/docs/products/marketplace/',
                            },
                            {
                                name: 'Intégrations',
                                src: 'https://docs.checkbook.io/docs/',
                            },
                        ],
                    },
                    {
                        name: 'Ressources',
                        items: [
                            {
                                name: 'Blog',
                                src: '/blog/',
                            },
                            {
                                name: 'Presse',
                                src: '/press/',
                            },
                            {
                                name: 'Études de cas',
                                src: '/resource/case-studies/',
                            },
                            {
                                name: 'Logos',
                                src: '/fr-ca/resource/logos/',
                            },
                            {
                                name: 'Politique de confidentialité',
                                src: '/resource/privacy/',
                            },
                            {
                                name: 'Conditions d\'utilisation',
                                src: '/company/terms-individual/',
                            },
                        ],
                    },
                ],
            },
            {
                rows: [
                    {
                        name: 'Contact',
                        items: [
                            { name: 'support@checkbook.io' },
                            { name: '(650) 761-0008' },
                            { name: 'San Mateo, CA' },
                        ],
                    },
                    {
                        name: 'Nous suivre',
                        items: [
                            {
                                name: 'Facebook',
                                src: 'https://www.facebook.com/Checkbook/',
                            },
                            {
                                name: 'Linkedin',
                                src: 'https://www.linkedin.com/company/checkbook/',
                            },
                            {
                                name: 'Twitter',
                                src: 'https://twitter.com/checkbook',
                            },
                        ],
                    },
                ],
            },
        ],
    },
};
